import { render, staticRenderFns } from "./Filesystem.vue?vue&type=template&id=32b10518&scoped=true&"
import script from "./Filesystem.vue?vue&type=script&lang=js&"
export * from "./Filesystem.vue?vue&type=script&lang=js&"
import style0 from "./Filesystem.vue?vue&type=style&index=0&id=32b10518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b10518",
  null
  
)

export default component.exports